module.exports = __webpack_public_path__ + "img/newsletter-page-image-desktop.87c69da7.jpg";